import React from 'react';
import { motion } from 'framer-motion';
import { Gift, Check } from 'lucide-react';
const bonuses = [{
  num: 1,
  title: 'Calculadora Cero-Desperdicio',
  desc: 'Cotizá en 3 minutos',
  value: '$35.000'
}, {
  num: 2,
  title: 'Lista Maestra de Herrajes',
  desc: '20 herrajes + sustitutos',
  value: '$28.000'
}, {
  num: 3,
  title: 'Checklist Anti-Errores',
  desc: 'Cero desperdicio de placa',
  value: '$25.000'
}, {
  num: 4,
  title: 'Scripts de Venta',
  desc: '60 mensajes listos para usar',
  value: '$32.000'
}, {
  num: 5,
  title: 'Plantillas de Perforado',
  desc: 'Precisión de fábrica',
  value: '$22.000'
}, {
  num: 6,
  title: 'Guía de Instalación Segura',
  desc: 'Anclajes para paredes argentinas',
  value: '$28.000'
}];
export function Bonuses() {
  return <section className="py-12 md:py-16 bg-white" data-id="element-15">
      <div className="container mx-auto px-4 max-w-4xl" data-id="element-16">
        <div className="text-center mb-8" data-id="element-17">
          <h2 className="text-2xl md:text-4xl font-black text-wood-dark mb-2" data-id="element-18">
            LOS 6 BONOS — <span className="text-green-600" data-id="element-19">GRATIS</span> EN
            AMBAS OFERTAS
          </h2>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 15
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="bg-white rounded-2xl shadow-warm overflow-hidden border border-wood-light/15 mb-8" data-id="element-20">
          <div className="hidden md:grid grid-cols-[1fr_1fr_120px] bg-wood-dark text-cream text-sm font-bold uppercase tracking-wider" data-id="element-21">
            <div className="p-3" data-id="element-22">Bono</div>
            <div className="p-3" data-id="element-23">Qué resuelve</div>
            <div className="p-3 text-center" data-id="element-24">Valor</div>
          </div>
          {bonuses.map((bonus, index) => <div key={index} className={`grid grid-cols-1 md:grid-cols-[1fr_1fr_120px] border-b border-wood-light/10 last:border-b-0 ${index % 2 === 0 ? 'bg-white' : 'bg-cream-dark/50'}`} data-id="element-25">
              <div className="p-3 flex items-center gap-2" data-id="element-26">
                <Gift className="w-4 h-4 text-amber flex-shrink-0" data-id="element-27" />
                <span className="font-bold text-wood-dark text-sm" data-id="element-28">
                  {bonus.num} — {bonus.title}
                </span>
              </div>
              <div className="px-3 pb-2 md:p-3 flex items-center text-sm text-charcoal/70" data-id="element-29">
                {bonus.desc}
              </div>
              <div className="px-3 pb-3 md:p-3 flex items-center justify-start md:justify-center gap-2 text-sm" data-id="element-30">
                <span className="text-charcoal/40 line-through" data-id="element-31">
                  {bonus.value}
                </span>
                <span className="text-green-600 font-black flex items-center" data-id="element-32">
                  <Check className="w-4 h-4 mr-0.5" data-id="element-33" />
                  GRATIS
                </span>
              </div>
            </div>)}
        </motion.div>

        <div className="text-center bg-amber/10 border-2 border-amber border-dashed rounded-xl p-4" data-id="element-34">
          <span className="text-charcoal/50 line-through font-bold mr-3" data-id="element-35">
            $170.000
          </span>
          <span className="text-2xl font-black text-green-600" data-id="element-36">→ GRATIS</span>
        </div>
      </div>
    </section>;
}